import { get, merge, set } from 'lodash';
import { getUserJwt } from '../../context/AuthHelper';
import { METHOD_GET, METHOD_POST } from '../constants/apis';
import { STRAPI_URL } from '../constants/url';
import { getQueryString } from './Population';

/**
 * Authenticates the user
 * @param {string} userName | username entered by user
 * @param {string} password | password entered by user
 * @returns | returns a responseBody from the API
 */
export default async function AuthUser(userName: string, password: string) {
	let response = await fetch(`${STRAPI_URL}/api/auth/local`, {
		method: METHOD_POST,
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({ identifier: userName, password: password }),
	});

	if (response.ok) {
		let responseData = await response.json();
		return responseData;
	}

	const err = await response.text();
	throw new Error(err);
}

export async function GetUserMe(jwt = '') {
	let poplevel = [{ Person: 'id', 'Person.Organisation': 'Geschaeftsbezogene_Daten_Name_Der_Organisation' }];
	let filter: any[] = [];
	let sort: any[] = [];
	let pagination: object = {};
	let fields: any = [];
	let response = await fetch(`${STRAPI_URL}/api/users/me${getQueryString(poplevel, filter, sort, pagination, fields)}`, {
		method: METHOD_GET,
		headers: {
			Authorization: `Bearer ${jwt ? jwt : getUserJwt()}`,
		},
	});

	if (!response.ok) {
		throw new Error(await response.text());
	}
	const responseData = await response.json();
	return responseData;
}

export async function ChangeUserPassword(data: Record<string, any>) {
	// let data = {
	// 	currentPassword: oldPassword,
	// 	password: newPassword,
	// 	passwordConfirmation: newPasswordRepeat,
	// };

	let response = await fetch(`${STRAPI_URL}/api/auth/change-password`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${getUserJwt()}`,
		},
		body: JSON.stringify(data),
	});

	if (response.ok) {
		let responseData = await response.json();
		return responseData;
	}

	const err = await response.text();
	throw new Error(err);
}

export async function CheckIfUserAndOrganisationExist(organisationData: any = {}, loginDaten?: any, personDaten?: any) {
	let bodyData: any = {
		data: {
			unternehmen: get(organisationData, 'attributes', {}),
			performRegister: false,
		},
	};
	// console.log(' body data ', bodyData);
	if (loginDaten) {
		// console.log('logindaten is there ', loginDaten);
		merge(bodyData.data, loginDaten);
		// set(bodyData, 'data', loginDaten);
	}
	if (personDaten) {
		// console.log(' person daten ist therer ', personDaten);
		set(bodyData, 'data.person', get(personDaten, 'attributes'));
	}

	// console.log(' body data before fetch  ', bodyData);

	let response: any = await fetch(`${STRAPI_URL}/api/auth/local/register`, {
		method: METHOD_POST,
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(bodyData.data),
	});
	if (!response.ok) {
		throw new Error(response);
	}
	let responseData = await response.json();
	return responseData;
}

export async function RegisterUserAndOrganisation(
	organisationData: any,
	loginDetails: any = {},
	personData: any,
	registerUserOnly: boolean = false,
	personId: number = 0,
	organisationId: number = 0
) {
	let data = {
		...loginDetails,
		blocked: false,
		confirmed: false,
		person: get(personData, 'attributes', {}),
		unternehmen: get(organisationData, 'attributes', {}),
		performRegister: true,
		registerUserOnly: registerUserOnly,
	};

	if (personId) {
		set(data, 'Person', personId);
	}
	if (organisationId) {
		set(data, 'ZuwendungsempfaengerId', organisationId);
	}
	let response = await fetch(`${STRAPI_URL}/api/auth/local/register`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	});

	if (response.ok) {
		let responseData = await response.json();
		return responseData;
	}

	const err = await response.text();
	throw new Error(err);
}

export async function ConfirmUserEmail(confirmationToken: string) {
	let response = await fetch(`${STRAPI_URL}/api/auth/email-confirmation?confirmation=${confirmationToken}`, {
		method: METHOD_GET,
	});
	return response;
}

export async function ResetPassword(data: any) {
	let response = await fetch(`${STRAPI_URL}/api/auth/reset-password`, {
		method: METHOD_POST,
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	});

	if (response.ok) {
		let responseData = await response.json();
		return responseData;
	}

	const err = await response.text();
	throw new Error(err);
}

/**
 * Initiates the password reset process for a user.
 * @param {string} username - The username of the user.
 * @returns {Promise<any>} - The response from the API.
 */
export async function ForgotUserPassword(username: string) {
	let response = await fetch(`${STRAPI_URL}/api/auth/forgot-password`, {
		method: METHOD_POST,
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			username: username,
		}),
	});

	if (response.ok) {
		let responseData = await response.json();
		return responseData;
	}

	const err = await response.text();
	throw new Error(err);
}
